import * as ex from "excalibur";
import { Resources } from "../../Resources";
import { Player } from "../../player";

import { goToScene } from "../../main";
import FarmerJackson from "../../actors/characters/farmerJackson";
import Colin from "../../actors/characters/colin";
import FarmersMarketCommerce from "../farmersMarketCommerce";
import { playerState } from "../../state/stateManager";
import OldLady from "../../actors/characters/oldLady";
import Marvin from "../../actors/characters/marvin";
import Bill from "../../actors/characters/bill";

export default class FarmersMarket extends ex.Scene {
  constructor() {
    super();
    const player = new Player(18 * 16, 18 * 16);
    this.player = player;
    this.player.lastDir = "up";
    this.player.wearingVeil = false;
    this.player.z = 5;
    let notice = new ex.Actor({
      pos: new ex.Vector(20 * 16, 7 * 16),
      height: 24,
      width: 100,
      color: ex.Color.fromHex("#80530f"),
    });
    this.colin = new Colin({ x: 17 * 16, y: 12 * 16 });
    this.colin.z = 4;
  }
  onInitialize(engine) {
    engine.add("farmersMarketCommerce", FarmersMarketCommerce);
    Resources.FarmersMarketMap.addToScene(this);
    console.log("mccartys: adding player: ", this.player);
    this.player.lastDir = "up";
    // Resources.AppleCider.play(0.2);
    // Resources.AppleCider.loop = true;
    this.add(this.player);
    this.add(this.colin);
    this.player.cutScene = false;
    // this.player = Resources.HouseMap.getObjectsByName("player");

    this.camera.zoom = 1;
    // const map_bounds = ex.BoundingBox.fromDimension(
    //   Resources.TownMap.map.width * Resources.TownMap.map.tilewidth + 10,
    //   Resources.TownMap.map.height * Resources.TownMap.map.tileheight + 10,
    //   ex.Vector.Zero,
    //   Resources.TownMap.pos
    // );
    // this.camera.strategy.limitCameraBounds(map_bounds);
    this.camera.strategy.lockToActor(this.player);
    this.door = new ex.Trigger({
      pos: new ex.Vector(17 * 16 + 8, 19 * 16),
      width: 60,
      height: 16,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        goToScene("town", { x: 16 * 16, y: 27 * 16, direction: "down" });
      },
    });
    this.add(this.door);
    this.interactBarrier = new ex.Trigger({
      pos: new ex.Vector(18 * 16, 14 * 16 + 8),
      width: 96,
      height: 18,
      filter: (actor) => {
        return actor.name === "player";
      },
      action: () => {
        this.colin.startInteraction(this.player.lastDir, this.player);
      },
    });
    this.add(this.interactBarrier);

    this.player.on("collisionstart", (e) => {
      console.log("collided");
      this.interacting = e.other.owner.name;
    });
    this.player.on("collisionend", (e) => {
      console.log("collided");
      this.interacting = null;
    });
  }
  onActivate(data) {
    if (data.data) {
      console.log("have location data: ", data.data);
      this.player.pos = new ex.Vector(data.data.x, data.data.y);
    }
    let content = playerState.getContent();
    if (content.npcLocations.jackson.location == 1) {
      if (this.jackson == null || this.jackson == undefined) {
        this.jackson = new FarmerJackson(
          { x: 13 * 16, y: 14 * 16 },
          "farmersMarket"
        );
        this.add(this.jackson);
      }
    }
    if (content.npcLocations.margie.location == 1) {
      if (this.margie == null || this.margie == undefined) {
        this.margie = new OldLady({ x: 23 * 16, y: 13 * 16 }, "farmersMarket");
        this.margie.z = 4;
        this.add(this.margie);
      }
    }
    if (content.npcLocations.bill.location == 1) {
      if (this.bill == null || this.bill == undefined) {
        this.bill = new Bill({ x: 19 * 16, y: 12 * 16 }, "farmersMarket");
        this.bill.z = 4;
        this.add(this.bill);
      }
    }
    if (content.npcLocations.marvin.location == 2) {
      if (this.marvin == null || this.marvin == undefined) {
        this.marvin = new Marvin({ x: 26 * 16, y: 14 * 16 }, "farmersMarket");
        this.marvin.z = 4;
        this.add(this.marvin);
      }
    }
  }
  onPostUpdate() {
    if (this.engine.input.keyboard.wasPressed(ex.Keys.Space)) {
      if (this.interacting !== null) {
        console.log("collide: this.interacting: ", this.interacting);
        this[this.interacting].startInteraction(
          this.player.lastDir,
          this.player
        );
      }
    }
  }
}
